import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";

export enum CommentThreadType {
  INVESTIGATION_REPORT = "INVESTIGATION_REPORT",
  SCN_PROCEEDING = "SCN_PROCEEDING",
  FIC = "FIC",
  CASE_OVERVIEW = "CASE_OVERVIEW",
  PRE_SCN_FIC = "PRE_SCN_FIC",
}

export enum CommentEntityType {
  CASE = "CASE",
}

export interface IComment {
  comment_id: string;
  comment: string;
  commentor: string;
  commented_at: string;
}

export interface GetCommentsResponse {
  comments: IComment[];
}

export interface AddCommentRequest {
  thread_type: CommentThreadType;
  entity_type: CommentEntityType;
  entity_id: string;
  comment: string;
}

export interface AddCommentResponse {
  comment_id: string;
  commented_at: string;
}

export const CommentsAPI = {
  get: async (
    case_id: string,
    thread_type: CommentThreadType,
    entity_type: CommentEntityType,
    entity_id: string,
  ) => {
    const response: AxiosResponse<GetCommentsResponse> =
      await axiosInstance.get(`/v1/cases/${case_id}/comments`, {
        params: {
          thread_type: thread_type,
          entity_type: entity_type,
          entity_id: entity_id,
        },
      });

    return response.data;
  },

  add: async (case_id: string, request: AddCommentRequest) => {
    const response: AxiosResponse<AddCommentResponse> =
      await axiosInstance.post(`/v1/cases/${case_id}/comments`, request);
    return response.data;
  },
};
